const getApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_API_URL;

  if (configuredUrl) {
    return configuredUrl.replace(/\/$/, '');
  }

  return '/api';
};

export default getApiBaseUrl;
